import { useEffect, useState } from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

import { ResourceFilter } from '@monorepo/shared/src/providers/ResourcesProvider/types';

const getTranslation = (key) => translate('resources', key);

const useSectionTilte = (selectedFilters: ResourceFilter[]): { title: string } => {
  const [title, setTitle] = useState(getTranslation('allResources'));

  useEffect(() => {
    setTitle(
      selectedFilters.length === 0 ? getTranslation('allResources') : getTranslation('filteredBy')
    );
  }, [selectedFilters]);

  return {
    title,
  };
};

export default useSectionTilte;
